import type { CardProps } from '@mui/material';
import { Box, Card, Tooltip, Typography } from '@mui/material';
import React from 'react';

interface TypedCardProps extends CardProps {
  typeName?: string;
  typeColor?: string;
  typeDescription?: string;
}

const TypedCard: React.FC<TypedCardProps> = ({ typeName, typeColor, typeDescription, children, ...cardProps }) => {
  return (
    <Card {...cardProps} sx={{ containerType: 'inline-size', position: 'relative', ...cardProps.sx }}>
      {typeName && (
        <Tooltip title={typeDescription ?? typeName} placement="left">
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              backgroundColor: typeColor || '#1976d2',
              color: 'white',
              p: '4px 12px',
              borderBottomLeftRadius: '8px',
              borderTopRightRadius: 'inherit',
              zIndex: 1,
            }}
          >
            <Typography variant="caption" fontWeight="600">
              {typeName}
            </Typography>
          </Box>
        </Tooltip>
      )}
      {children}
    </Card>
  );
};

export default TypedCard;
